import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-nav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="app-nav">
      <div class="wrapper">
        <a [routerLink]="[ '/schedule' ]" routerLinkActive="active">Schedule</a>
        <a [routerLink]="[ '/meals' ]" routerLinkActive="active">Meals</a>
        <a [routerLink]="[ '/workouts' ]" routerLinkActive="active">WorkOuts</a>
      </div>
    </div>
  `,
  styleUrls: ['./app-nav.component.scss']
})
export class AppNavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
